module.exports = __webpack_public_path__ + "img/stamp.f5709d34.png";